var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-play';
                    var viewUrl = 'sprite.svg#view-icon-play';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 30 35.8',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };